import type { ModernSubscription } from '../../types';
import { PlanTypes } from '../../types';

export function isModernEnterprisePlan(modernSubscription: ModernSubscription) {
  const { planType } = modernSubscription;
  if (planType === null || planType === undefined) {
    return false;
  }
  return [PlanTypes.ENTERPRISE_TRIAL, PlanTypes.ENTERPRISE, PlanTypes.ENTERPRISE2023].includes(planType);
}
